/** @format */

import React from 'react'
import { Provider } from 'react-redux'

import { render } from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'

import { init } from '@sentry/react'
import { Integrations } from '@sentry/tracing'

import { initializeApp } from 'firebase/app'
import { FirebaseDatabaseProvider } from '@react-firebase/database'

import { firebaseConfig } from './services/baseURL'
import { store } from './services/store'
import { App } from './App'
import './index.scss'

init({
  dsn: 'https://52f28c3d4b1d4074bea1f5dfb2a209c9@o341738.ingest.sentry.io/6118612',
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
})

initializeApp(firebaseConfig)

render(
  <Router>
    <Provider store={store}>
      <FirebaseDatabaseProvider>
        <App />
      </FirebaseDatabaseProvider>
    </Provider>
  </Router>,
  document.getElementById('root'),
)
